// extracted by mini-css-extract-plugin
export default {"container":"zSAZkZ4EWbqfrPI2lIDc","body":"AVIX8Spl8u39r9TdPM7A","error":"X96eRSoTYo8ma08iSq9m","alternatives":"sqLhya88pUYXgsWB8YhZ"};